import * as React from 'react';
import { useState } from 'react';
import { Col, Row, Form, Nav, Card, Button, ListGroup, Badge, Alert, Modal, Spinner } from "react-bootstrap";
import * as yup from 'yup';
import * as formik from 'formik';
import atlasApi from "../utils/atlasapi";
import schemas from "../data/dataSchemas";


export interface diagProps {
	owner: object;
	onClose: (value: string) => void;
}

const { Formik } = formik;

const states = [
	{label:'Terminated', value:'Terminated'},
	{label:'On Hold', value:'On Hold'},
];

class DialogTerminate extends React.Component {

	

	constructor(props) {
		super(props);
		
		this.state = {
			validated: false,
			status: {sent:null, message:''}
		}
		
		//this.owner = schemas.owner.cast(this.props.owner);
		
	}
	updateStatus(s){
		var x = {...this.state};
		x.status = s;
		this.setState(x);
		this.forceUpdate();
	}


	handleClose(data){
		this.props.onClose(data);
		this.updateStatus({sent:null, message:''});
	};
	handleOnShow(e){
		this.forceUpdate();
	};

	handleSubmit(data){

		
		this.updateStatus({sent:false, success:false, message:'Changing project state...'});
		//saveguard for testing

		var data = {...data,
			projectId: this.props.projectid
		}
	
		
		//console.log(setMainScenario);
		atlasApi.projectState(this.props.projectid, data).then((response)=>{
			if(response.success){
				this.updateStatus({sent:true, success:true, message:'The project state was changed'});
				setTimeout(()=>this.handleClose(), 2000);
			}
			else
				this.updateStatus({sent:true, success:false, message:'Error changing state'});
			
			
			
		}).catch((e)=>{
			this.updateStatus({sent:true, success:false, message:'Error changing state'});
		});
		//this.updateStatus({sent:false, success:false, message:'Saving...'});
		
	};


	render() {
		return (
			<Modal show={this.props.setup.open} onHide={(e)=>this.handleClose(e)} onShow={(e)=>this.handleOnShow(e)} centered>
				<Modal.Header closeButton>
					<Modal.Title>Terminate project</Modal.Title>
				</Modal.Header>

				<Formik validationSchema={schemas.projectState} onSubmit={this.handleSubmit.bind(this)} initialValues={{state:states[0].value}}>	
					{({ handleSubmit, handleChange, values, touched, errors }) => (
						<Form noValidate onSubmit={handleSubmit}>
							{this.state.status.sent === null ? (
								<React.Fragment>
									<Modal.Body>
									
										<Row className="mb-3">
											<Form.Group as={Col} md="12" controlId="validationFormik01">
												<Form.Label>State</Form.Label>
												<Form.Select name="state" defaultValue={values.type ? values.type : null} options={states} onChange={handleChange}>
													{states.map(option => (
														<option key={option.value} value={option.value}>{option.label}</option>
													))}
												</Form.Select>
												<Form.Control.Feedback>Looks good!</Form.Control.Feedback>
											</Form.Group>
										</Row>
										<Row>
											<Form.Group as={Col} md="12" controlId="validationFormik00">
												<Form.Label>Log message</Form.Label>
												<Form.Control as="textarea" name="log" onChange={handleChange} placeholder="Write your message here" isValid={touched.log && !errors.log} isInvalid={touched.log && errors.log}/>
											</Form.Group>
											
											<Form.Control.Feedback>
												{errors.log}
											</Form.Control.Feedback>
										</Row>
									</Modal.Body>
									
									<Modal.Footer>
										<Button className="me-auto" variant="secondary" onClick={(e)=>this.handleClose()}>Close</Button>
										<Button variant="danger" type="submit">Terminate project</Button>
									</Modal.Footer>
								</React.Fragment>
							) : (
							<Modal.Body>
								<Row className="mb-3 dialog-feedback">
									<Col xs="12" className="dialog-feedback-icon text-center">
										{
										this.state.status.sent ?
											(this.state.status.success ? 
												(<i className="ri-checkbox-circle-line text-success"></i>)
												:
												(<i className="ri-error-warning-line text-warning"></i>)
											)
											:
											(<Spinner animation="border" variant="info" className="mt-5" />)
										}
									</Col>
									<Col xs="12" className="dialog-feedback-text mb-5">
										{this.state.status.message}
									</Col>
								</Row>
							</Modal.Body>	
							)}
						</Form>
					)}	
				</Formik>
			</Modal>
		);
	}
}

export default DialogTerminate;